import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { NotificationContainerView } from './container_view';
/**
 *  Styles will be inlined since these components will be rendered for PDF generation
 */
export const SmsPreview = ({ messages }) => {
    if (!messages) {
        return null;
    }
    return (_jsx(NotificationContainerView, { children: _jsx("div", { style: {
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                width: '100%',
                backgroundColor: 'rgb(226,225,225)',
                borderRadius: 'calc(1rem - 4px)',
                overflowY: 'auto',
            }, children: _jsxs("div", { style: {
                    background: '#fff',
                    maxWidth: '360px',
                    margin: '2em 3em',
                    marginInlineStart: '2em',
                    padding: '1em 1em 1em 0.5em',
                    borderRadius: '5px',
                    position: 'relative',
                    alignSelf: 'flex-end',
                }, children: [_jsx("div", { children: _jsx("div", { style: { overflowWrap: 'break-word' }, children: messages.plain }) }), _jsx("div", { style: {
                            position: 'absolute',
                            width: '0',
                            height: '0',
                            top: '10px',
                            border: '20px solid white',
                            borderInlineEndColor: 'transparent',
                            borderBottomColor: 'transparent',
                            borderTop: '0',
                            marginTop: '-10px',
                            insetInlineEnd: '-36px',
                        } })] }) }) }));
};
//# sourceMappingURL=sms.preview.component.js.map